import React from 'react';
import { format } from 'date-fns'
import { API_ADDRESS, australiaTimezones, states, streetTypesList } from 'config';
import { message } from 'antd';
import Papa from 'papaparse'
import { uniqBy } from 'lodash';
import crypto from 'crypto'; // Storing encrypted version of password

const algorithm = 'aes-256-cbc'  // Encryption type
const iv = Buffer.from('c63c985e17ccde12c17dba4c6abdac37', 'hex')
const secretKey = Buffer.from('cbf82fb39b5c3915dc9dcea6b9db0edb7574fdb75cef602f0fcb9e6a4e0871a1', 'hex')

// const iv = crypto.randomBytes(16) // iv for Encryption
// const secretKey = crypto.randomBytes(32) // Do not change the secretKey

export function encryptJSON(plainJSON: string) {
	const cipher = crypto.createCipheriv(algorithm, secretKey, iv)
	let encryptedJSON = cipher.update(JSON.stringify(plainJSON), 'utf8', 'hex')
	encryptedJSON += cipher.final('hex')
	return encryptedJSON
}

export function decryptJSON(encryptedJSON: string) {
    const decipher = crypto.createDecipheriv(algorithm, secretKey, iv);
    let decryptedJSON = decipher.update(encryptedJSON, 'hex', 'utf8');
    decryptedJSON += decipher.final('utf8');
    return JSON.parse(decryptedJSON)
}

export function checkToken(data: any){
	if( data?.message && data.message.includes('token') ){
		localStorage.clear()
		sessionStorage.clear()
		window.location.href='/login'
	}
}

export function daysBetweenTodayAndIsoDate(isoDate: string){
	const today		= new Date();
	const date		= new Date(isoDate);
	const timeDiff	= Math.abs(date.getTime() - today.getTime());
	const diffDays	= Math.ceil(timeDiff / (1000 * 3600 * 24)); 
	return diffDays;
}

export const loadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = (error) => reject(error);
        img.src = src;
    });
}

export function ucwords(str: string){
	return str?.replace(/\b\w/g, (letter) => letter.toUpperCase()) || str;
}

export function sortObjects(objects: any, field: string){
	if (typeof objects?.length === 'undefined'){
		return []
	}
	const newObjects = [...objects]

	return newObjects.sort(function(a,b){
		const field1 = a?.[field]?.toString()?.toUpperCase() ?? '';
		const field2 = b?.[field]?.toString()?.toUpperCase() ?? '';
		if (field1 < field2){
			return -1;
		}
		if (field1 > field2){
			return 1;
		}
		return 0;
	})
}

export function getUniques(jsonArray){
	const keys = Object.keys(jsonArray[0])
	const uniques = {}
	for(let i = 0; i < keys.length; i++){
		uniques[keys[i]] = uniqBy(jsonArray, keys[i]).sort((a,b) => {
			if(a?.[keys[i]] > b?.[keys[i]]){
			  return 1
			}
			return -1
		  }).map((item) => ({
			text: item?.[keys[i]],
			value: item?.[keys[i]],
		  }))
	}
	console.log("uniques", uniques)
}

export function getListingIdFromUrl(url){
	let listingId = ''
	switch(true){
	  case (url?.includes('airbnb.com')):
		if(url.includes('rooms/')){
		  listingId = url.includes('?') ? url.split('rooms/')[1].split('?')[0] : url.split('rooms/')[1]
		}
		if(url.includes('luxury/listing/')){
		  listingId = url.includes('?') ? url.split('luxury/listing/')?.[1].split('?')[0] : url?.split('luxury/listing/')?.[1]
		}
	  break;
	  case (url?.toLowerCase()?.includes('booking.com')):
		listingId = url.split('hotel/au/')?.[1]?.split('.')?.[0] ?? ''
		break;
	  case (url?.toLowerCase()?.includes('vrbo.com')):
		if(url.includes('holiday-rental/p')){
		  listingId = url.includes('?') ? url.split('holiday-rental/p')[1].split('?')[0] : url.split('holiday-rental/p')[1]
		}
		break;
	  case (url?.toLowerCase()?.includes('homeaway.com')):
		if(url.includes('rental/p')){
		  listingId = url.includes('?') ? url.split('rental/p')[1].split('?')[0] : url.split('rental/p')[1]
		}
		break;
		default:
			listingId = ''
	}
	return listingId
  }

export function getSiteFromUrl(url: string){
	switch(true){
	  case (url?.includes('airbnb.com')):
		return 'airbnb'
	  case (url?.toLowerCase()?.includes('booking.com')):
		return 'booking'
	  case (url?.toLowerCase()?.includes('vrbo.com')):
		return 'vrbo'
	  case (url?.toLowerCase()?.includes('homeaway.com')):
		return 'homeaway'
		default:
			return ''
	}
}

export function searchListings(currentValue: string, listings: any){

	if(currentValue?.length < 1 || currentValue === 'clear'){
		return listings
	}

	const search = currentValue?.trim()

	return listings.filter( listing => {
		const splitSearch = search.split(' ')
		if(splitSearch.length > 1){
		  let matches = 0
		  for(let i = 0; i < splitSearch.length; i++){
			  matches+= listing?.title?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.propertyType?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.roomType?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.host?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.comment?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.suburb?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.indicatedSuburb?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.evidenceLink?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.evidenceLink2.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.streetName?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.address?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase())
			  || listing?.listingId?.toString()?.toLowerCase().includes(splitSearch[i]?.toLowerCase()) === true ? 1 : 0
		  }
		  if(matches > 1){
			return true
		  }
		}		

		return (
			listing?.title?.toString()?.toLowerCase().includes(search?.toLowerCase())
		|| listing?.propertyType?.toString()?.toLowerCase().includes(search?.toLowerCase())
		|| listing?.roomType?.toString()?.toLowerCase().includes(search?.toLowerCase())
		|| listing?.host?.toString()?.toLowerCase().includes(search?.toLowerCase())
		|| listing?.comment?.toString()?.toLowerCase().includes(search?.toLowerCase())
		|| listing?.address?.toString()?.toLowerCase().includes(search?.toLowerCase())
		|| listing?.suburb?.toString()?.toLowerCase().includes(search?.toLowerCase())
		|| listing?.listingId?.toString()?.toLowerCase().includes(search?.toLowerCase())
		);
	})
}

export function searchProperties(currentValue: string, properties: any){

	if(currentValue?.length < 1 || currentValue === 'clear'){
		return properties
	}

	return properties.filter( property => 
		( property?.long && property?.long?.toLowerCase().includes(currentValue?.toLowerCase()) )
		|| ( property?.propertyType && property?.propertyType?.toLowerCase().includes(currentValue?.toLowerCase()) )
		|| ( property?.matchType && property?.matchType?.toLowerCase().includes(currentValue?.toLowerCase()) )
		|| ( property?.listingType && property?.listingType?.toLowerCase().includes(currentValue?.toLowerCase()) )
		|| ( property?.host && property?.host?.toLowerCase().includes(currentValue?.toLowerCase()) )
		|| ( property?.suburb && property?.suburb?.toLowerCase().includes(currentValue?.toLowerCase()) )
		|| ( property?._id && property?._id?.toLowerCase().includes(currentValue?.toLowerCase()) )
	);
}

export function homeawayLink(listingId: string){
	return `https://www.vrbo.com/en-au/holiday-rental/p${listingId}`
}

export function listingsToCSV(listings: any){
	return listings.map( listing => {
		let link;
		switch (listing.site) {
			case "airbnb":
				link = `https://www.airbnb.com/rooms/${listing.listingId}`;
				break;
			case "homeaway":
				link = homeawayLink(listing.listingId);
				break;
			case "booking":
				link = `https://www.booking.com/hotel/au/${listing.listingId}.en-gb.html`;
				break;
			default:
					link = `https://www.google.com/search?q=${listing.site} ${listing.listingId}`;
		}

		return {
			_id: listing._id,
			data: listing.data,
			listingId: listing.listingId,
			site: listing?.site || '',
			ownerId: listing?.ownerId || '',
			suburbId: listing?.suburbId || '',
			suburb: listing?.suburb || '', // listing.propertyListing?.property?.address?.suburb ? listing.propertyListing.property.address.suburb : '',
			link,
			roomType: listing?.data?.listingType && listing.data.listingType !== "" ? listing?.data.listingType : listing.propertyListing?.listingType ? listing.propertyListing.listingType : '',
			propertyType: listing?.data?.propertyType && listing.data.propertyType !== "" ? listing.data.propertyType : listing.propertyListing?.propertyType ? listing.propertyListing.propertyType : '',
			isRemoved: listing.isActive ? 'no' : 'yes',
			isExact: listing.isExact ? 'yes' : 'no',
			host: listing.data?.hostName ? listing.data.hostName : '',
			title: listing.data?.title?.replace(/["]+/g, ''),
			guests: listing.data?.guests || 0,
			bedrooms: listing.data?.bedrooms ? listing.data.bedrooms : 0,
			bathrooms: listing.data?.bathrooms ? listing.data.bathrooms : 0,
			indicatedSuburb: listing.data?.indicatedSuburb ?  listing.data?.indicatedSuburb : '',
			address: listing.propertyListing?.property?.address?.long ? listing.propertyListing.property.address.long : '',
			street: listing.propertyListing?.property?.address?.streetName ? listing.propertyListing.property.address.streetName : '',
			propertyId: listing.propertyListing?.property?.propertyId || '',
			property: listing.propertyListing?.property?._id || '',
			created: format(new Date(listing.created), 'yyyy-MM-dd'),
			updated: format(new Date(listing.updated), 'yyyy-MM-dd'),
			lat: listing.location ? listing.location.coordinates[1] : '',
			lng: listing.location ? listing.location.coordinates[0] : '',
			geoLink: listing.location ? `https://www.google.com/maps?q=loc:${listing.location.coordinates[1]},${listing.location.coordinates[0]}&z=15`: '',
			imageSearch: `https://www.google.com/searchbyimage?image_url=${listing.data?.images?.[0]}`,
			evidenceLink: listing.propertyListing?.evidenceLink ? listing.propertyListing?.evidenceLink : '',
			evidenceLink2: listing.propertyListing?.evidenceLink2 ? listing.propertyListing?.evidenceLink2 : '',
			unitNo: listing.propertyListing?.property?.address?.unitNo ? listing.propertyListing.property.address.unitNo : '',
			streetNo: listing.propertyListing?.property?.address?.streetNo ? listing.propertyListing.property.address.streetNo : '',
			streetName: listing.propertyListing?.property?.address?.streetName ? listing.propertyListing.property.address.streetName : '',
			streetType: listing.propertyListing?.property?.address?.streetType ? listing.propertyListing.property.address.streetType : '',
			matchType: listing.matchType === "" && listing.propertyListing?.property?.matchType ? listing.propertyListing.property.matchType : (listing?.matchType ? listing.matchType : ''),
			comment: listing.propertyListing?.comment ? listing.propertyListing?.comment : '',
			userId: listing?.userId || "",
			user: listing?.user || "",
		}
		
	})

}

export async function getPropertyTypes(config){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/get-property-types`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export async function getRoomTypes(config){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/get-room-types`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export async function enableScraper(e: any, getScrapeQueue: any, config: any){
	const scraper = e.target.id
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/scrape/scraper/${scraper}/${e.target.checked ? 'true':'false'}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any
			getScrapeQueue()
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export const convertCsvToJson = (file, callback) => {
	Papa.parse(file, {
	  complete: (result) => {
		// Assuming the CSV has headers, result.data will be an array of objects
		const jsonData = result.data;
		console.log("jsonData",jsonData)
  
		// Call the callback function with the JSON data
		callback(jsonData);
		// return jsonData
	  },
	  header: true, // Set to true if your CSV file has headers
	  dynamicTyping: true, // Convert numeric and boolean values to their types
	  skipEmptyLines: true, // Skip empty lines in the CSV file
	});
  };

export async function saveListing(listing: any, config: any){
	// console.log("functions.tsx saveListing", listing)
	const abortController = new AbortController()
	let saveResult = null
	try{
		const customConfig = {
			...config,
			method: 'POST',
			signal: abortController.signal,
			body: JSON.stringify(listing),
		}
		await fetch(`${API_ADDRESS}/admin/save-listing`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			if(data?.message){
				message.success(data.message)
			}
			if(data?.error){
				message.error(data.error)
			}
			saveResult = data
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
	}catch(err){
		// ...
		abortController.abort()
	}
	return saveResult
}

export async function getOwnerBookings(ownerId: string, startDate: string, endDate: string, output: string, config: any){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		// /admin/owner-bookings/5cf5f5efbadb725b3984c3de?startDate=2023-08-20&endDate=2023-12-04
		// await fetch(`http://3.27.61.184/admin/owner-bookings/${ownerId}?startDate=${startDate}&endDate=${endDate}&output=${output}`,customConfig)
		await fetch(`${API_ADDRESS}/admin/owner-bookings/${ownerId}?startDate=${startDate}&endDate=${endDate}&output=${output}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export async function getOwnerReport(ownerId: string, config: any){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/owner-report/${ownerId}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export async function getStateScrapes(state: string, yearMonth: any, config: any){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/scrapes/${state}/${yearMonth}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

	export async function listSuburbs(ownerId, config){
		const abortController = new AbortController()
		try{
			const customConfig = {
				...config,
				signal: abortController.signal,
			}
			let result = []
			await fetch(`${API_ADDRESS}/admin/councils/list-suburbs?ownerId=${ownerId}`,customConfig)
			.then( response => response.json() )
			.then( data => {
				checkToken(data)
				result = data //  as any	
			})
			.catch((error) => {
				if(error.name === 'AbortError'){
					// ...
					abortController.abort()
				}
			})
			return result
		}catch(err){
			// ...
			abortController.abort()
		}
		return []
	}

export async function getCSVListings(options, config){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			method: "POST",
			body: JSON.stringify(options),
			signal: abortController.signal,
		}
		let result = []
		// await fetch(`${API_ADDRESS}/admin/councils/csv-listings?suburbId=${suburbId}&ownerId=${ownerId}&start=${start}&limit=${limit}&filters=${btoa(JSON.stringify(filters))}`,customConfig)
		await fetch(`${API_ADDRESS}/admin/councils/csv-listings`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}


export function getNewerReportListings(oldestReportListings: any, newerReportListings: any){
	// console.log(oldestReportListings, newerReportListings)
	const replacementsFound = oldestReportListings.filter( oldListing => {
		return newerReportListings.find( newListing => {
			return (newListing as any)?.Link?.toLowerCase() === (oldListing as any)?.Link?.toLowerCase()
		})
	}).map( exact => exact?.Link?.toLowerCase() ?? null )
	return [
		...oldestReportListings.filter( oldListing => !replacementsFound.includes(oldListing?.Link?.toLowerCase() ?? '') ),
		...newerReportListings,
	]
}

export async function uploadReport(report: any, config: any){
	const abortController = new AbortController()
	let result = false
	try{
		const customConfig = {
			...config,
			method: 'POST',
			signal: abortController.signal,
			body: JSON.stringify(report),
		}
		const response = await fetch(`${API_ADDRESS}/admin/upload-report`,customConfig)
		const data = await response.json()
		checkToken(data)
		if(data?.message){
			message.success(data.message)
			result = true
		}
		if(data?.error){
			message.error(data.error)
			result = false
		}
	}catch(err){
		// ...
		result = false
		abortController.abort()
	}
	return result
}

export async function getImportLogs(ownerId: string, config: any){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/councils/get-import-logs?ownerId=${ownerId}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export async function getImportLog(importId: string, ownerId: string, config: any){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/councils/get-import-log?importId=${importId}&ownerId=${ownerId}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}
export async function getReportLogs(ownerId: string, config: any){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/councils/get-report-logs?ownerId=${ownerId}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export async function getReportLog(reportId: string, ownerId: string, config: any){
	const abortController = new AbortController()
	try{
		const customConfig = {
			...config,
			signal: abortController.signal,
		}
		let result = []
		await fetch(`${API_ADDRESS}/admin/councils/get-report-log?reportId=${reportId}&ownerId=${ownerId}`,customConfig)
		.then( response => response.json() )
		.then( data => {
			checkToken(data)
			result = data //  as any	
		})
		.catch((error) => {
			if(error.name === 'AbortError'){
				// ...
				abortController.abort()
			}
		})
		return result
	}catch(err){
		// ...
		abortController.abort()
	}
	return []
}

export async function csvSuburbListings(ownerId: string, config: any){
	const response = await fetch(`${API_ADDRESS}/admin/councils/csv-suburbs-listings?ownerId=${ownerId}`,config)
	const data = response.json();
	const newListings = data as any

	checkToken(data)

	return newListings
}

export const getCSVProperties = async (ownerId: string, suburbName: string, config: any): Promise<any[]> => {
	const url = `${API_ADDRESS}/dashboard/suburb/csv?ownerId=${ownerId}&dataType=properties&suburbName=${suburbName}`
	const response = await fetch(url,config)
	const data = response.json();
	checkToken(data)
	return data
}

export const getExcelColumnName = (i: number, rowIndex: number) => {
	const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	let columnName = '';
	let index = i
  
	// If the index is less than 26 (A to Z), return the corresponding letter
	if (index < 26) {
	  return `${alphabet[index]}${rowIndex}`;
	}
  
	// If the index is greater than or equal to 26, handle double letters (AA, AB, etc.)
	while (index >= 0) {
	  columnName = `${alphabet[index % 26]}${columnName}`;
	  index = Math.floor(index / 26) - 1;
  
	  // If we reach the end of the alphabet, adjust the index and continue
	  if (index < 0) {
		index += 26;
	  }
		break;
	}
  
	return `${columnName}${rowIndex}`
  }

export const excelColumnToNumber = (column) => {
	let result = 0;
	for (let i = 0; i < column.length; i++) {
	  result = result * 26 + column.charCodeAt(i) - 64; // 64 is the character code of 'A'
	}
	return result;
}

  // ######################
  // #   extractAddress   #
  // ######################

export const extractAddress = (streetAddress) => {
    const s = streetAddress?.toLowerCase() ?? ''
    let addressEnd = ''
    // console.log(s)
    // Define a regular expression pattern to match unit/level and street address
    const result = {
      unit: '',
      level: '',
      streetNo: '',
      streetName: '',
      streetType: '',
	  streetTypes: [],
    }
	if(s.length < 1){
		return result
	}

	if( s.indexOf('/') < 0 && s.indexOf(', ') < 0 ){
        addressEnd = s
    }

    if( s.indexOf('/') > -1 ){

        const unit = s.match(/(factory |kiosk |shop |sign |storage |suite |tower |unit |lot )(\d+)+/) ?? s.match(/^(\d+)+/)
        const level = s.match(/(level )(\d+)+/)

        // console.log("unit",unit)
        // console.log("level",level)

        if(unit && unit.length > 0){
          result.unit = unit?.[unit.length - 1]
        }

        if(level && level.length > 0){
          result.level = level?.[1] === 'level ' ? level[level.length - 1] : ''
        }
        addressEnd = s.split('/')?.[1]
    }
    // Street
    if( s.indexOf(', ') > -1 ){
        addressEnd = s.split(', ')?.[1]
    }
    const addressItems = addressEnd?.split(' ')
    result.streetType = addressItems[addressItems.length -1]

    const streetTypesAbbreviated = []
    const streetTypesFull = []
    // see if abbreviated
    // if (result?.streetType?.length > 0) {
      for (let i = 0; i < streetTypesList.length; i++) {
        streetTypesAbbreviated.push(Object.keys(streetTypesList[i])[0])
        streetTypesFull.push(Object.values(streetTypesList[i])[0])
      }
    // }
	
	if(states.includes(addressItems[addressItems.length -1].toLowerCase()) ){
		// Find which is street (Broome has Suburb State in address)
		const streetIndex = addressItems.findIndex( item => streetTypesFull.includes(item))
		if(streetIndex > 0){
			result.streetType = addressItems[streetIndex]
		}
	}

    // Check for abbreviated street type and change to full
    if(streetTypesAbbreviated.includes(result.streetType) || streetTypesFull.includes(result.streetType)){
		for(let i = 0; i < streetTypesAbbreviated.length; i++){
		  if(streetTypesAbbreviated[i] === result.streetType || streetTypesFull[i] === result.streetType){
			result.streetTypes.push(streetTypesAbbreviated[i])
			result.streetTypes.push(streetTypesFull[i])
		  }
		}

		// console.log(`found ${result.streetTypes.length}`,result.streetTypes)
		if(result.streetTypes.length < 2){
			result.streetType = '' // streetTypesFull[streetTypesAbbreviated.indexOf(result.streetType)]
			// console.log("result.streetType",result.streetType)
		}else if(result.streetTypes.includes('street') && result.streetTypes.includes('st') && !result.streetTypes.includes('rd') && !result.streetTypes.includes('road')){
			  result.streetTypes.push('road')
			  result.streetTypes.push('rd')
		}else if(result.streetTypes.includes('road') && result.streetTypes.includes('rd') && !result.streetTypes.includes('st') && !result.streetTypes.includes('street')){
			result.streetTypes.push('street')
			result.streetTypes.push('st')
		}
    }

	// See if there is a number at the start
    const streetNo = addressEnd.match(/(\d+)(-){1,}(\d+){1,}/) ?? addressEnd.match(/(\w+){0,}(\d+){1,}(\w+){0,}(\s){1,}/)
    if( streetNo?.length > 0 ){
      result.streetNo = streetNo[0]?.trim()
    }
    const streetItems = []
    if(addressItems.length > 0){
      for(let i = 1; i < addressItems.length -1; i++){
          streetItems.push(addressItems[i])
      }
      result.streetName = streetItems.join(' ')
    }
    return result
}

  // ####################
  // #   matchAddress   #
  // ####################

export const matchAddress = (council, bnbguard) =>  {
	if(council?.trim()?.toLowerCase() === bnbguard?.trim()?.toLowerCase()){
		return true
	}
    const councilAddress = extractAddress(council);
    const bnbguardAddress = extractAddress(bnbguard);

    let matchingStreetType = councilAddress?.streetType === bnbguardAddress?.streetType
    if(!matchingStreetType && councilAddress.streetTypes.includes(bnbguardAddress?.streetType) ){
      matchingStreetType = true
    }
    if(!matchingStreetType && bnbguardAddress.streetTypes.includes(councilAddress?.streetType) ){
      matchingStreetType = true
    }

	if(councilAddress.streetName === 'beach' && bnbguardAddress.streetName === 'beach' && bnbguardAddress.streetNo === '2b'){
		console.log("councilAddress",councilAddress)
		console.log("bnbguardAddress",bnbguardAddress);
	}

    // Matching street address
    if(councilAddress?.streetName === bnbguardAddress?.streetName && matchingStreetType){
        // console.log('have matching street name and type') // will have to check for abbreviated street type
        // Now match streetNo
        if(councilAddress?.streetNo === bnbguardAddress?.streetNo){
          // console.log('have matching street number')
          // Now match unit
          if(councilAddress.unit.length > 0 && bnbguardAddress.unit.length > 0){
              if(councilAddress.unit === bnbguardAddress.unit){
                  // console.log('have matching unit')
                  return true
              }
			  if(councilAddress.level.length > 0){
				const unitFormat1 = `${councilAddress.level}${parseInt(councilAddress.unit) < 10 ? `0${councilAddress.unit}` : councilAddress.unit}` // Unit Format 1: Unit 1/Level 9 = 901
				if(bnbguardAddress.unit === unitFormat1){
					// console.log('have matching unit by level')
					return true
				}
              }
			  return false
          }
		  if((councilAddress.unit.length > 0 && bnbguardAddress.unit.length < 1) || (bnbguardAddress.unit.length > 0 && councilAddress.unit.length < 1)){
			return false
		  }
          return true
        }
    }
    return false
  }


  /*
  if(matchAddress("Unit 1/Level 9, 435 Nepean Highway","901/435 Nepean Highway")){
    console.log("Found match")
  }
  */

export const getReportFormat = (propertyListing, suburbs, councilData) => {
	// console.log("councilData",councilData)
	// Exact
	let councilProperty = councilData.find( data => data?.prop_address?.trim()?.toLowerCase() === propertyListing?.property?.address?.long?.trim()?.toLowerCase() )
	// Partial
	if(!councilProperty){
		// Match Unit etc.
		console.log("attempting to match address")
		councilProperty = councilData.find( data => matchAddress(data?.prop_address, propertyListing?.property?.address?.long) )
		if(!councilProperty){
			councilProperty = councilData.find( data => data?.prop_address?.trim()?.toLowerCase().includes(propertyListing?.property?.address?.long?.trim()?.toLowerCase()))
			if(councilProperty){
				/*
				councilProperty = {
					...councilProperty,
					'Council Address': '',
					'PropertyID': '',
				}
				*/
			}else{
				console.log("councilProperty not found",councilProperty)
			}
		}else{
			console.log("councilProperty matchAddress",councilProperty)
		}
	}else{
		console.log("councilProperty exact",councilProperty)
	}
	// matchAddress(data?.prop_address, propertyListing?.property?.address?.long) 
	// const councilProperty = councilData.find( data => matchAddress(data?.prop_address, propertyListing?.property?.address?.long) )
	const suburb = suburbs.find( suburb => propertyListing?.suburbId?.toString() === suburb?._id?.toString() )
	const date = new Date(propertyListing?.property?.created ?? null)
	date.toLocaleDateString('en-AU', { timeZone: australiaTimezones[suburb?.state ?? australiaTimezones.nsw] }) // 'Australia/Sydney'
	const createdDate = format(new Date(date.toString()), 'd/M/yy') // h:mm a')
	return {
		'Match Type'		: propertyListing?.linkedListing?.isActive && propertyListing.linkedListing.isActive === true ? ucwords(propertyListing?.property?.matchType ?? '') : 'Removed',
		'Scrape Address'	: ucwords(propertyListing?.property?.address?.long?.trim() ?? ''),
		'Council Address'	: ucwords(councilProperty?.prop_address ?? ''),
		'Suburb'			: ucwords(suburb?.name) ?? 'unknown',
		'Link'				: propertyListing?.url ?? '',
		'Property Type'		: propertyListing?.propertyType ?? '',
		'Listing Type'		: propertyListing?.listingType ?? '',
		'Host'				: ucwords(propertyListing?.linkedListing?.data?.hostName ?? propertyListing?.host ?? ''),
		'PropertyID'		: councilProperty?.property_no ?? '', // Council assigned ID will overwrite
		'Evidence Link'		: propertyListing?.evidenceLink ?? '',
		'Evidence Link 2'	: propertyListing?.evidenceLink2 ?? '',
		// 'Customer Notes'	: propertyListing?.comment ?? '',
		'Created'			: createdDate,
	}
}

export const formatPerformanceOverview = (performanceOverview: any, state: string) => {
	const date = new Date(performanceOverview?.['Report Date'] ?? null)
	date.toLocaleDateString('en-AU', { timeZone: australiaTimezones?.[state] ?? australiaTimezones.nsw }) // 'Australia/Sydney'
	const reportDate = format(new Date(date.toString()), 'd/M/yy') // h:mm a')
	return [{
		...performanceOverview,
		'Report Date': reportDate,
	}]
}

export const createReport = (data: any) => {
	const { propertyListings, suburbs, councilData, summary, performanceOverview } = data
	const exact = (sortObjects(propertyListings,'property.address.long') as any).filter( propertyListing => propertyListing?.property?.matchType === 'exact' && propertyListing?.linkedListing?.isActive === true ).map( propertyListing => {
		return getReportFormat(propertyListing, suburbs, councilData)
	}) ?? {}
	const commercial = propertyListings.filter( propertyListing => propertyListing?.property?.matchType === 'commercial' ).map( propertyListing => {
		return getReportFormat(propertyListing, suburbs, councilData)
	}) ?? {}
	const possibleMatches = propertyListings.filter( propertyListing => {
		if(
			(propertyListing?.linkedListing?.isActive && !propertyListing.linkedListing.isActive === true)
		 || propertyListing?.linkedListing?.matchType === 'removed'){
			return false
		}
		return (propertyListing?.property?.matchType === 'need more evidence' || propertyListing?.property?.matchType === 'need unit id')
	}).map( propertyListing => {
		return getReportFormat(propertyListing, suburbs, councilData)
	}) ?? {}
	const removed = propertyListings.filter( propertyListing => propertyListing?.linkedListing?.isActive === false )
	.map( propertyListing => {
		return getReportFormat(propertyListing, suburbs, councilData)
	}) ?? {}

	const exactHeadingRow				= 4
	const exactDataRow					= 7

	const commercialHeadingRow			= exactDataRow + exact.length + 3
	const commercialDataRow				= commercialHeadingRow + 3

	const possibleMatchesHeadingRow		= commercialDataRow + commercial.length + 3
	const possibleMatchesDataRow		= possibleMatchesHeadingRow + 3

	const removedHeadingRow				= possibleMatchesDataRow + possibleMatches.length + 3
	const removedDataRow				= removedHeadingRow + 3

	const summaryHeadingRow				= removedDataRow + removed.length + 3
	const summaryDataRow				= summaryHeadingRow + 3

	const performanceOverviewHeadingRow	= summaryDataRow + summary.length + 3
	const performanceOverviewDataRow	= performanceOverviewHeadingRow + 3

	const sheets = [
		{
			sheetName: "BNBGUARD REPORT",
			data: [
				{
					cell: 'A1',
					value: 'BNBGUARD REPORT',
				},
				{
					cell: `A${exactHeadingRow}`,
					value: 'EXACT',
				},
				{
					cell: `A${exactDataRow}`,
					value: exact,
				},
				{
					cell: `A${commercialHeadingRow}`,
					value: 'COMMERCIAL',
				},
				{
					cell: `A${commercialDataRow}`,
					value: commercial,
				},
				{
					cell: `A${possibleMatchesHeadingRow}`,
					value: 'POSSIBLE MATCHES',
				},
				{
					cell: `A${possibleMatchesDataRow}`,
					value: possibleMatches,
				},
				{
					cell: `A${removedHeadingRow}`,
					value: 'REMOVED (only if address was available on BNBGUARD previously)',
				},
				{
					cell: `A${removedDataRow}`,
					value: removed,
				},
				{
					cell: `A${summaryHeadingRow}`,
					value: 'SUMMARY',
				},
				{
					cell: `A${summaryDataRow}`,
					value: summary,
				},
				{
					cell: `A${performanceOverviewHeadingRow}`,
					value: 'PERFORMANCE OVERVIEW',
				},
				{
					cell: `A${performanceOverviewDataRow}`,
					value: formatPerformanceOverview(performanceOverview, suburbs[0]?.state),
				},
			],
		},
		{
			sheetName: "PROPERTIES",
			data: [
				{
					cell: 'A1',
					value: 'PROPERTIES',
				},
				{
					cell: 'A5',
					value: exact,
				},
			],
		},
	];
	return sheets
}
